import { IconButton } from 'app/agriculture/components/Button/Button';
import { ImageModal } from 'app/agriculture/components/Image/ImageModal';
import { getTimestampDateFormat } from 'app/agriculture/components/Timestamp/timestampUtils';
import { DownloadIcon, ExpandIcon } from 'app/agriculture/icons';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { format as formatDate } from 'date-fns';
import classNames from 'classnames';
import { useCallback, useContext, useState } from 'react';
import './TrailCamImageBox.scss';
import { Link } from 'react-router-dom';
import { AsideStateContext } from 'app/agriculture/components/ContentBox/context/AsideStateContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

export function TrailCamImageBox() {
    const { device } = useContext(DeviceDetailContext);
    const { setIsAsideOpen } = useContext(AsideStateContext);

    const { id, name } = device;

    const [modalOpen, setModalOpen] = useState(false);

    const handleClose = useCallback(() => {
        setIsAsideOpen(false);
    }, [setIsAsideOpen]);

    const handleModalOpen = useCallback(() => {
        setModalOpen(true);
    }, []);

    const handleModalClose = useCallback(() => {
        setModalOpen(false);
    }, []);

    const imageSnapshot = useSnapshot({ snapshotType: 'Image', shelfLife: null, parentId: id });
    if (imageSnapshot?.imageFilename == null) return null;
    const { imageFilename, timestamp } = imageSnapshot;

    // This is required so that the download works
    const imagePath = `${window.origin}/${imageFilename}`;

    return (
        <div className={classNames('TrailCamImageBox')} data-testid="TrailCamImageBox">
            <div className="TrailCamImageBox__header">
                <h5 className="TrailCamImageBox__heading" title={name}>
                    {name}
                </h5>
                <div className="TrailCamImageBox__actions">
                    <Link
                        className="TrailCamImageBox__download"
                        to={imagePath}
                        download={imagePath}
                        target="_blank"
                    >
                        <IconButton
                            variant="textonly"
                            tooltip="Download Photo"
                            icon={<DownloadIcon />}
                        />
                    </Link>
                    <IconButton
                        id="TrailCamImageBoxClose"
                        className="TrailCamImageBox__close"
                        icon="close"
                        tooltip="Close"
                        onClick={handleClose}
                    />
                </div>
            </div>
            <div className="TrailCamImageBox__content">
                <IconButton
                    id="TrailCamImageBoxModalButton"
                    className="TrailCamImageBox__button"
                    icon={<ExpandIcon size={16} />}
                    tooltip="Expand TrailCamImageBox"
                    onClick={handleModalOpen}
                    variant="textonly"
                />
                <img className="TrailCamImageBox__image" src={imageFilename} alt="" />
                <div className="TrailCamImageBox__timestamp">
                    {formatDate(timestamp, getTimestampDateFormat(timestamp))}
                </div>
            </div>

            <ImageModal
                open={modalOpen}
                onClose={handleModalClose}
                src={imageFilename}
                timestamp={timestamp}
                className="TrailCamImageBox__modal"
                heading={name}
            />
        </div>
    );
}
